import React, { useCallback, useEffect, useState, useRef } from "react";
import styles from "./style.module.css";

import CalDel from "../../../images/cal-del.png";
import Sidebar from "../../partials/Sidebar";
import Header from "../../partials/Header";

import { Link, useNavigate } from "react-router-dom";
import { Button, Popconfirm, message } from "antd";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { motion } from "framer-motion";
import HashLoader from "react-spinners/ClipLoader";
import { Modal, notification } from "antd";
import InputMask from "react-input-mask";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../Redux/Authentication";
import "./keyboard.css";
import InvidLockerSelect from "./InvidLockerSelect";
import SuffolkLockerSelect from "./SuffolkLockerSelect";
import invidLockerStyles from "./InvidLockerSelect.module.css";
import { isInvidBankSite } from "./invidBankSites";

const isSuffolkCountySlug = (slug) =>
  String(slug || "").toLowerCase().trim() === "suffolkcounty";
function PhoneInput(props) {
  return (
    <InputMask
      mask="+1999 999 9999"
      value={props.value}
      onChange={props.onChange}
      placeholder="+1123 123 1234"
      className="form-control"
    ></InputMask>
  );
}
const streaming_url = process.env.REACT_APP_STREAMIN_SOCKET_URL;
const url = process.env.REACT_APP_APP_BACK_URL;
const react_base_url = process.env.REACT_APP_BASE_URL;
const isValidMongoId = (id) =>
  typeof id === "string" && /^[a-f\d]{24}$/i.test(id.trim());

const PickupBook = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const isAuthenticated = useSelector((state) => state.user);
  const siteName = useSelector((state) => state.siteName);
  const siteSlug =
    localStorage.getItem("siteuser") ||
    sessionStorage.getItem("siteuser") ||
    "";
  const [isInvidPickupSite, setIsInvidPickupSite] = useState(() =>
    isInvidBankSite(siteSlug)
  );
  const [isSuffolkCountySite, setIsSuffolkCountySite] = useState(() =>
    isSuffolkCountySlug(siteSlug)
  );
  const usesLockerImage = isInvidPickupSite || isSuffolkCountySite;
  const [temparature, settemparature] = useState("70.0");
  const [pickupData, setPickupData] = useState({});
  const [sizes, setSizes] = useState([]);
  const [lockers, setLockers] = useState([]);
  const [siteLockers, setSiteLockers] = useState([]);
  const [doorInputs, setDoorInputs] = useState({});
  const [orderStep, setOrderStep] = useState(true);
  const [sizeStep, setSizeStep] = useState(false);
  const [lockerStep, setLockerStep] = useState(false);
  const [customerStep, setcustomerStep] = useState(false);
  const [isSizeSelected, setIsSizeSelected] = useState("");
  const [sizeLoader, setSizeLoader] = useState(true);
  const [isSizeDisplay, setIsSizeDisplay] = useState(false);
  const [sizeNotFound, setSizeNotFound] = useState(false);
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [firstStep, setFirstStep] = useState(true);
  const [secStep, setSecStep] = useState(false);
  const [thirdStep, setThirdStep] = useState(false);
  const [fourStep, setFourStep] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [invidLockerModalOpen, setInvidLockerModalOpen] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [selectedLocker, setSelectedLocker] = useState("");
  const confirmedLockerIdRef = useRef("");
  const [disableSelect, setDisableSelect] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [enableKeyboard, setEnableKeyboard] = useState(false);
  const [loader, setLoader] = useState(false);
  const [streamUrl, setStreamUrl] = useState("");
  const [credentials, setCredentials] = useState({
    size_id: "",
    locker_id: "",
    customer_email: "",
  });
  const keyLayout = [
    ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
    ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
    ["@", "Z", "X", "C", "V", "B", "N", "M", "."],
    ["Backspace", "Space", "Enter"],
  ];
  const enableKey = () => {
    setEnableKeyboard(!enableKeyboard);
  };
  const [input, setInput] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [activeInput, setActiveInput] = useState("email"); // Track which input is active
  const [capsLock, setCapsLock] = useState(false);
  const [shift, setShift] = useState(false);
  const handleKeyPress = (key) => {
    if (key === "Backspace") {
      if (activeInput === "name") {
        setCustomerName(customerName.slice(0, -1));
      } else {
        setInput(input.slice(0, -1));
      }
    } else if (key === "Enter") {
      if (activeInput === "name") {
        setCustomerName(customerName + "\n");
      } else {
        setInput(input + "\n");
      }
    } else if (key === "Space") {
      if (activeInput === "name") {
        setCustomerName(customerName + " ");
      } else {
        setInput(input + " ");
      }
    } else if (key === "Caps") {
      setCapsLock(!capsLock);
    } else if (key === "Shift") {
      setShift(true);
      setTimeout(() => setShift(false), 500);
    } else {
      const char = capsLock || shift ? key.toUpperCase() : key.toLowerCase();
      if (activeInput === "name") {
        setCustomerName(customerName + char);
      } else {
        setInput(input + char);
      }
    }
  };
  let inputRef = useRef(null);
  const orderNumberInputRef = useRef(null);
  const handleInput = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    inputRef.current?.focus();
  }, []);
  // Focus order number input on mount
  useEffect(() => {
    if (orderNumberInputRef.current) {
      orderNumberInputRef.current.focus();
    }
  }, []);
  const loadStreamOnCanvas = (canvasId, streamUrl) => {
    const canvas = document.getElementById(canvasId);
    const encoded = encodeURIComponent(streamUrl);
    if (canvas && window.loadPlayer) {
      try {
        /* eslint-disable no-undef */
        loadPlayer({
          url: `${streaming_url}/stream/pickup/fisheye/${encoded}`,
          canvas: canvas,
        });
        /* eslint-enable no-undef */
      } catch (error) {
        console.error(`Error loading stream on ${canvasId}:`, error);
      }
    } else {
      console.error(`Canvas ${canvasId} not found or loadPlayer not available`);
    }
  };

  useEffect(() => {
    if (streamUrl) {
      const script = document.createElement("script");
      script.src =
        "https://cdn.jsdelivr.net/npm/rtsp-relay@1.7.0/browser/index.js";
      script.async = true;
      script.onload = () => {
        // Load stream on the main canvas
        loadStreamOnCanvas("canvas", streamUrl);
      };
      document.head.appendChild(script);
      return () => {
        // Clean up the script element if the component unmounts
        document.head.removeChild(script);
      };
    }
  }, [streamUrl]);
  const handle_logout = useCallback(async () => {
    await localStorage.removeItem("token");
    dispatch(logout());
    const siteuser = localStorage.getItem("siteuser");
    if (siteuser) {
      navigate(`/${siteuser}/pin`);
    } else {
      const siteUserSessions = sessionStorage.getItem("siteuser");
      navigate(`/${siteUserSessions}/pin`);
    }
  }, [dispatch, navigate]);
  const [phone, setPhone] = useState("");
  const handlePhoneInput = (e) => {
    setPhone(e.target.value);
  };
  const [code, setCode] = useState("");
  const [orderKeyboardMode, setOrderKeyboardMode] = useState("numeric");
  const orderAlphaLayout = [
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
    ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
    ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
    ["Z", "X", "C", "V", "B", "N", "M"],
    ["@", "#", "-", "_", ".", "/", "$", "&"],
    ["Backspace", "Space", "Clear", "Enter"],
  ];
  // Function to handle digit button click
  const handleDigitClick = (digit) => {
    setCode((prevCode) => prevCode + digit);
  };
  // Function to handle the delete button click
  const handleDeleteDigit = () => {
    setCode((prevCode) => prevCode.slice(0, -1));
  };
  const handleOrderKeyboardPress = (key) => {
    if (key === "Backspace") {
      setCode((prevCode) => prevCode.slice(0, -1));
    } else if (key === "Space") {
      setCode((prevCode) => prevCode + " ");
    } else if (key === "Clear") {
      setCode("");
    } else if (key === "Enter") {
      HandleSelectedOrderNumber();
    } else {
      setCode((prevCode) => prevCode + key);
    }
  };
  useEffect(() => {
    sizeData();
  }, []);

  useEffect(() => {
    if (isInvidBankSite(siteSlug)) {
      setIsInvidPickupSite(true);
    }
    if (isSuffolkCountySlug(siteSlug)) {
      setIsSuffolkCountySite(true);
    }
    if (isInvidBankSite(siteSlug) || isSuffolkCountySlug(siteSlug)) {
      return;
    }
    const siteId = isAuthenticated?.site_id;
    if (!siteId) {
      return;
    }
    (async () => {
      try {
        const response = await fetch(`${url}/api/sites/getSite/${siteId}`);
        const json = await response.json();
        if (json.success && isInvidBankSite(json.site?.slug)) {
          setIsInvidPickupSite(true);
        }
        if (json.success && isSuffolkCountySlug(json.site?.slug)) {
          setIsSuffolkCountySite(true);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [siteSlug, isAuthenticated?.site_id]);

  useEffect(() => {
    if (!usesLockerImage) {
      return;
    }
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("auth-token", localStorage.getItem("token"));
    fetch(`${url}/api/lockers/site/all`, {
      mode: "cors",
      method: "GET",
      headers,
    })
      .then((res) => res.json())
      .then((siteJson) => {
        if (siteJson.success) {
          setSiteLockers(siteJson.lockers || []);
        }
      })
      .catch((siteErr) => console.error(siteErr));
  }, [usesLockerImage]);

  useEffect(() => {
    if (!isSuffolkCountySite) return undefined;
    let stopped = false;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("auth-token", localStorage.getItem("token"));
    const loadDoorStatus = () => {
      fetch(`${url}/api/lockers/door/status`, {
        mode: "cors",
        method: "GET",
        headers,
      })
        .then((res) => res.json())
        .then((json) => {
          if (!stopped && json?.inputs) setDoorInputs(json.inputs);
        })
        .catch(() => {});
    };
    loadDoorStatus();
    const timer = setInterval(loadDoorStatus, 4000);
    return () => {
      stopped = true;
      clearInterval(timer);
    };
  }, [isSuffolkCountySite]);

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(() => {
      fetchData();
    }, 5000);

    return () => {
      // stopCamera();
      clearInterval(intervalId);
    };
  }, [temparature]);
  const fetchData = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      const response = await fetch(`${url}/api/lockers/get/temperature`, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });

      const json = await response.json();
      if (json.success) {
        settemparature(json.data);
      }
    } catch (error) {}
  };
  const sizeData = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setSizeLoader(true);
      setIsSizeDisplay(false);
      setSizeNotFound(false);
      const response = await fetch(`${url}/api/lockers/size/available`, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });
      const json = await response.json();
      if (json.success) {
        setStreamUrl(json?.streamUrl || "");
        if (json.data.length > 0) {
          setSizes(json.data);
          setSizeLoader(false);
          setIsSizeDisplay(true);
          setSizeNotFound(false);
        } else {
          setSizeLoader(false);
          setIsSizeDisplay(false);
          setSizeNotFound(true);
        }
      } else {
        setSizeLoader(false);
        setIsSizeDisplay(false);
        setSizeNotFound(true);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const HandleSelectedOrderNumber = async () => {
    if (code === "") {
      notification.error({
        message: "Failed",
        description: "Please enter order number",
        duration: 3,
      });
      return;
    } else if (code.trim().length < 3) {
      notification.error({
        message: "Failed",
        description: "Please enter at least 3 characters for order number",
        duration: 3,
      });
      return;
    } else {
      setOrderStep(false);
      setSizeStep(true);
      setLockerStep(false);
      setcustomerStep(false);
      setFirstStep(true);
      setSecStep(true);
      setThirdStep(false);
      setFourStep(false);
    }
  };
  const HandleSelectedSize = async (size_id) => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setIsSizeSelected(size_id);
      const response = await fetch(`${url}/api/lockers/available`, {
        mode: "cors",
        method: "POST",
        body: JSON.stringify({
          size_id: size_id,
        }),
        headers: headers,
      });
      const json = await response.json();
      setIsSizeSelected(false);
      if (json.success) {
        setCredentials((prevCredentials) => ({
          ...prevCredentials,
          size_id: size_id,
        }));
        if (json.lockers.length > 0) {
          setLockers(json.lockers);
          setOrderStep(false);
          setSizeStep(false);
          setLockerStep(true);
          setcustomerStep(false);
          setFirstStep(true);
          setSecStep(true);
          setThirdStep(true);
          setFourStep(true);
          setDisableSelect(false);
          setSelectedLocker("");
          confirmedLockerIdRef.current = "";
          setCredentials((prev) => ({
            ...prev,
            locker_id: "",
          }));
          setShowConfirm(false);
        } else {
          notification.warning({
            message: "No lockers",
            description: "No lockers found for this size.",
            duration: 3,
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  const isLockerAvailable = (status) =>
    (status || "").toLowerCase() === "available";

  const persistLockerSelection = (lockerId, sizeId) => {
    if (!isValidMongoId(lockerId)) {
      return false;
    }
    confirmedLockerIdRef.current = lockerId;
    setSelectedLocker(lockerId);
    setCredentials((prev) => ({
      ...prev,
      locker_id: lockerId,
      ...(sizeId ? { size_id: sizeId } : {}),
    }));
    return true;
  };

  const HandleInvidBankLockerSelect = (locker, sizeRecord) => {
    if (!locker || !isLockerAvailable(locker.status)) {
      return;
    }
    const sizeId = locker.size_id || sizeRecord?._id;
    if (!persistLockerSelection(locker._id, sizeId)) {
      return;
    }
    setDisableSelect(true);
    setShowConfirm(false);
    setInvidLockerModalOpen(true);
  };

  const handleInvidActionModalClose = () => {
    setInvidLockerModalOpen(false);
  };

  const selectedInvidLocker = siteLockers.find((l) => l._id === selectedLocker);

  const HandleSelectedLocker = async (locker_id, lockerStatus) => {
    if (!isLockerAvailable(lockerStatus)) {
      return;
    }
    if (usesLockerImage) {
      if (!persistLockerSelection(locker_id)) {
        return;
      }
      setDisableSelect(true);
      setShowConfirm(false);
      return;
    }
    HandleConfirm(locker_id);
  };

  const HandleConfirm = async (locker_id) => {
    if (!persistLockerSelection(locker_id)) {
      notification.error({
        message: "Failed",
        description: "Please select a locker before continuing",
        duration: 3,
      });
      return;
    }
    setInvidLockerModalOpen(false);
    setOrderStep(false);
    setSizeStep(false);
    setLockerStep(false);
    setcustomerStep(true);
    setFirstStep(true);
    setSecStep(true);
    setThirdStep(true);
    setFourStep(true);
    setDisableSelect(false);
    setShowConfirm(false);
  };

  const HandleOpenLocker = async (locker_id) => {
    let state = "2";
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    setLoader(true);
    const response = await fetch(`${url}/api/lockers/relay/state/update`, {
      mode: "cors",
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        id: locker_id,
        state: state,
      }),
    });
    const json = await response.json();

    setLoader(false);
    if (json.success) {
      notification.success({
        message: "Success",
        description: json.message,
        duration: 3,
      });
      setShowConfirm(true);
    } else {
      notification.error({
        message: "Failed",
        description: json.error,
        duration: 3,
      });
    }
  };

  const formSubmit = async (e) => {
    try {
      e.preventDefault();
      const lockerId =
        confirmedLockerIdRef.current ||
        credentials.locker_id ||
        selectedLocker;
      if (!isValidMongoId(lockerId)) {
        notification.error({
          message: "Failed",
          description: "Please select a locker before submitting",
          duration: 3,
        });
        return;
      }
      if (!isValidMongoId(credentials.size_id)) {
        notification.error({
          message: "Failed",
          description: "Please select a locker size before submitting",
          duration: 3,
        });
        return;
      }
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setIsFormSubmit(true);
      const response = await fetch(`${url}/api/pickups/add`, {
        mode: "cors",
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          order_number: code,
          size_id: credentials.size_id,
          locker_id: lockerId,
          customer_name: customerName,
          customer_email: input,
          // customer_phone: phone,
          base_url: react_base_url,
        }),
      });
      const json = await response.json();
      setIsFormSubmit(false);
      if (json.success) {
        setPickupData(json?.pickup);
        confirmedLockerIdRef.current = "";
        setCredentials({
          size_id: "",
          locker_id: "",
          customer_email: "",
          // customer_phone: "",
        });
        setCode("");
        setCustomerName("");
        setInput("");
        setTimeout(() => {
          handle_logout();
        }, 5000);
        notification.success({
          message: "Success",
          description: "Pickup added Successfully",
          duration: 3,
        });
        setcustomerStep(false);
        setLockerStep(false);
        setSuccessMessage(true);
      } else {
        notification.error({
          message: "Failed",
          description: json.error,
          duration: 3,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  const HandleCustomerBck = async () => {
    if (usesLockerImage) {
      setOrderStep(false);
      setSizeStep(true);
      setLockerStep(false);
      setcustomerStep(false);
      setFirstStep(true);
      setSecStep(true);
      setThirdStep(false);
      setFourStep(false);
      setInvidLockerModalOpen(false);
      return;
    }
    setOrderStep(false);
    setSizeStep(false);
    setLockerStep(true);
    setcustomerStep(false);
    setFirstStep(true);
    setSecStep(true);
    setThirdStep(true);
    setFourStep(false);
  };
  const HandleSizeBck = async () => {
    setOrderStep(true);
    setSizeStep(false);
    setLockerStep(false);
    setcustomerStep(false);
    setFirstStep(true);
    setSecStep(false);
    setThirdStep(false);
    setFourStep(false);
    setSelectedLocker("");
    confirmedLockerIdRef.current = "";
    setCredentials((prev) => ({
      ...prev,
      locker_id: "",
      size_id: "",
    }));
    setDisableSelect(false);
    setShowConfirm(false);
    setLoader(false);
    setInvidLockerModalOpen(false);
  };
  const HandleLockerBack = async () => {
    setOrderStep(false);
    setSizeStep(true);
    setLockerStep(false);
    setcustomerStep(false);
    setFirstStep(true);
    setSecStep(true);
    setThirdStep(false);
    setFourStep(false);

    setDisableSelect(false);
    setSelectedLocker("");
    confirmedLockerIdRef.current = "";
    setCredentials((prev) => ({
      ...prev,
      locker_id: "",
    }));
    setShowConfirm(false);
    setLoader(false);
    setInvidLockerModalOpen(false);
  };
  const [isActive, setIsActive] = useState(false);
  const toggleActive = () => {
    setIsActive(!isActive);
  };
  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";
  return (
    <div className="general-dashboard">
      <div className="container-fluid">
        <div className="dashboard-top-row">
          <div className="row ">
            <div className="col-lg-4 my-auto">
              <div className="user-wrap">
                <h3>Book A Pickup</h3>
                <p>Book your pickup here</p>
              </div>
            </div>
            <div className="mt-3 d-flex justify-content-center align-items-center gap-2">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  position: "relative",
                  overflow: "hidden",
                  objectFit: "contain",
                  height: "120px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                }}
              >
                <canvas
                  id="canvas"
                  height="120"
                  width="200"
                  style={{
                    width: "200px",
                    height: "120px",
                    position: "static",
                    zIndex: "0",
                    display: `${
                      (isAuthenticated?.role.toLowerCase() === "admin" &&
                        isInvidPickupSite) ||
                      isAuthenticated?.role.toLowerCase() === "superadmin"
                        ? "block"
                        : "none"
                    }`,
                  }}
                ></canvas>
              </div>
              <h3 className="fw-700 bg-secondary text-white p-2 rounded shadow-sm">
                {temparature}°F
              </h3>
            </div>
            <div className="mt-3 d-flex justify-content-center align-items-center">
              <div className="steps-wrap">
                <div className={`step-cont ${firstStep ? "active" : ""}`}>
                  <span>01</span>
                </div>
                <div className={`step-cont ${secStep ? "active" : ""}`}>
                  <span>02</span>
                </div>
                <div className={`step-cont ${thirdStep ? "active" : ""}`}>
                  <span>03</span>
                </div>
                <div className={`step-cont ${fourStep ? "active" : ""}`}>
                  <span>04</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {orderStep && (
          <div className="calc-wrap-main">
            <div className="row text-center">
              {/* <div className="col-lg-6 my-auto">
                <img src={CalcLeft} alt="" />
              </div> */}
              <div className=" my-auto">
                <div className="calc-wrap">
                  <div className="cal-screen">
                    <input
                      placeholder="Enter Order Number"
                      type="text"
                      name=""
                      id="result"
                      ref={orderNumberInputRef}
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          HandleSelectedOrderNumber();
                        }
                      }}
                      autoComplete="off"
                      autoFocus
                    />
                  </div>
                  <div className="keys-wrap">
                    <div className="mb-2">
                      <button
                        type="button"
                        className="btn btn-prim w-auto"
                        onClick={() =>
                          setOrderKeyboardMode((prevMode) =>
                            prevMode === "numeric" ? "alphanumeric" : "numeric"
                          )
                        }
                      >
                        {orderKeyboardMode === "numeric"
                          ? "Use Letters & Symbols"
                          : "Use Numeric Keypad"}
                      </button>
                    </div>
                    {orderKeyboardMode === "numeric" ? (
                      <div className="row ">
                        <div className="col-4">
                          <button
                            className="btn-key"
                            onClick={() => handleDigitClick("1")}
                          >
                            <i>1</i>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            className="btn-key"
                            onClick={() => handleDigitClick("2")}
                          >
                            <i>2</i> <span>ABC</span>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            className="btn-key"
                            onClick={() => handleDigitClick("3")}
                          >
                            <i>3</i> <span>ABC</span>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            className="btn-key"
                            onClick={() => handleDigitClick("4")}
                          >
                            <i>4</i> <span>ABC</span>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            className="btn-key"
                            onClick={() => handleDigitClick("5")}
                          >
                            <i>5</i> <span>ABC</span>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            className="btn-key"
                            onClick={() => handleDigitClick("6")}
                          >
                            <i>6</i> <span>ABC</span>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            className="btn-key"
                            onClick={() => handleDigitClick("7")}
                          >
                            <i>7</i> <span>ABC</span>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            className="btn-key"
                            onClick={() => handleDigitClick("8")}
                          >
                            <i>8</i> <span>ABC</span>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            className="btn-key"
                            onClick={() => handleDigitClick("9")}
                          >
                            <i>9</i> <span>ABC</span>
                          </button>
                        </div>
                        <div className="col-8">
                          <button
                            className="btn-key"
                            onClick={() => handleDigitClick("0")}
                          >
                            <i>0</i>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            className="btn-delt"
                            onClick={handleDeleteDigit}
                          >
                            <img src={CalDel} alt="" />{" "}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="order-alpha-keyboard">
                        {orderAlphaLayout.map((row, rowIndex) => (
                          <div key={rowIndex} className="order-alpha-keyboard-row">
                            {row.map((key, index) => (
                              <button
                                key={index}
                                type="button"
                                onClick={() => handleOrderKeyboardPress(key)}
                                className={`order-alpha-key ${
                                  [
                                    "Backspace",
                                    "Enter",
                                    "Space",
                                    "Clear",
                                  ].includes(key)
                                    ? "special"
                                    : ""
                                }`}
                              >
                                {key}
                              </button>
                            ))}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="cont-btn-wrap">
                    <button
                      className="continue-btn"
                      onClick={HandleSelectedOrderNumber}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {sizeStep && (
          <div className="calc-wrap-main">
            <div className="form-box card-box">
              <h4 className="fw-bold">
                {isSuffolkCountySite
                  ? "SELECT LOCKER"
                  : isInvidPickupSite
                  ? "SELECT LOCKER FROM AVAILABLE BANK"
                  : "SELECT SIZE FROM AVAILABLE LOCKER"}
              </h4>
              <div className="row mt-3">
                {sizeLoader && (
                  <>
                    <div className="col-12 text-center">
                      <HashLoader
                        color={`#0b0d41`}
                        loading={sizeLoader}
                        size={40}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    </div>
                  </>
                )}
                {isSizeDisplay && isInvidPickupSite && (
                  <div className="col-12">
                    <InvidLockerSelect
                      sizes={sizes}
                      siteLockers={siteLockers}
                      busy={Boolean(isSizeSelected) || loader}
                      selectedLockerId={selectedLocker}
                      onSelectLocker={HandleInvidBankLockerSelect}
                    />
                  </div>
                )}
                {isSizeDisplay && isSuffolkCountySite && (
                  <div className="col-12">
                    <SuffolkLockerSelect
                      sizes={sizes}
                      siteLockers={siteLockers}
                      doorInputs={doorInputs}
                      busy={Boolean(isSizeSelected) || loader}
                      selectedLockerId={selectedLocker}
                      onSelectLocker={HandleInvidBankLockerSelect}
                    />
                  </div>
                )}
                {isSizeDisplay &&
                  !usesLockerImage &&
                  sizes.map((item, i) => (
                    <div className="col-lg-3 col-md-3 col-sm-6" key={item._id || i}>
                      <div
                        className="card"
                        style={{
                          background: "#EFF1FF",
                          borderRadius: "18px",
                          borderColor: "#EFF1FF",
                        }}
                      >
                        <div className="card-body text-center">
                          <h6>{item.size}</h6>
                          <p>{item.available_lockers} Available</p>
                          <button
                            type="submit"
                            className="btn btn-prim mt-2"
                            disabled={
                              item.available_lockers > 0 || isSizeSelected
                                ? ""
                                : "disabled"
                            }
                            onClick={() => {
                              HandleSelectedSize(item._id);
                            }}
                          >
                            SELECT
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                <div className="col-12 text-end mt-4">
                  <button
                    type="button"
                    className="btn btn-prim w-auto mt-2"
                    onClick={HandleSizeBck}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {lockerStep && (
          <div className="table-wrap">
            <div className="">
              <div className="table-responsive">
                <div className={styles.card_box}>
                  <div className={styles.tables_wrap}>
                    <table
                      className="table align-middle"
                      style={{
                        width: "100%",
                        tableLayout: "auto",
                      }}
                    >
                      <thead className="">
                        <tr>
                          <th style={{ textAlign: "left", width: "auto" }}>
                            #
                          </th>
                          <th style={{ textAlign: "left", width: "auto" }}>
                            Locker
                          </th>
                          <th style={{ textAlign: "left", width: "auto" }}>
                            Status
                          </th>
                          <th style={{ textAlign: "left", width: "auto" }}>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {lockers &&
                          lockers.map((item, i) => (
                            <motion.tr
                              key={item._id}
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              transition={{ duration: 1.2, delay: i * 0.1 }}
                              style={{
                                display:
                                  window.innerWidth < 768
                                    ? "flex"
                                    : "table-row",
                                flexDirection:
                                  window.innerWidth < 768 ? "column" : "row",
                              }}
                            >
                              <td style={{ textAlign: "left", width: "auto" }}>
                                {i + 1}
                              </td>
                              <td style={{ textAlign: "left", width: "auto" }}>
                                {item.number}
                              </td>
                              <td style={{ textAlign: "left", width: "auto" }}>
                                <span
                                  className={
                                    isLockerAvailable(item.status)
                                      ? styles.lockerStatusAvailable
                                      : styles.lockerStatusOccupied
                                  }
                                >
                                  {isLockerAvailable(item.status)
                                    ? "AVAILABLE"
                                    : "OCCUPIED"}
                                </span>
                              </td>
                              <td
                                className="d-flex gap-2 flex-wrap"
                                style={{ textAlign: "left", width: "auto" }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-prim btn-transparent w-auto"
                                  onClick={() => {
                                    HandleSelectedLocker(
                                      item._id,
                                      item.status
                                    );
                                  }}
                                  disabled={
                                    disableSelect ||
                                    !isLockerAvailable(item.status)
                                  }
                                  style={{
                                    padding: "5px 10px",
                                    fontSize: "0.9em",
                                  }}
                                >
                                  SELECT
                                </button>
                                {isInvidPickupSite &&
                                  isLockerAvailable(item.status) &&
                                  disableSelect &&
                                  selectedLocker === item._id && (
                                    <button
                                      type="button"
                                      className="btn btn-prim w-auto"
                                      onClick={() => {
                                        HandleOpenLocker(item._id);
                                      }}
                                      disabled={loader}
                                      style={{
                                        padding: "5px 10px",
                                        fontSize: "0.9em",
                                      }}
                                    >
                                      {loader
                                        ? "Opening.."
                                        : showConfirm &&
                                          selectedLocker === item._id
                                        ? "Re-open Locker"
                                        : "Open Locker"}
                                    </button>
                                  )}
                                {isInvidPickupSite &&
                                  isLockerAvailable(item.status) &&
                                  selectedLocker === item._id && (
                                    <button
                                      type="button"
                                      className="btn btn-prim w-auto"
                                      onClick={() => {
                                        HandleConfirm(item._id);
                                      }}
                                      style={{
                                        padding: "5px 10px",
                                        fontSize: "0.9em",
                                        backgroundColor:
                                          showConfirm &&
                                          selectedLocker === item._id
                                            ? "green"
                                            : "red",
                                      }}
                                    >
                                      Confirm
                                    </button>
                                  )}
                              </td>
                            </motion.tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-8 mt-5 text-end">
              <button
                type="button"
                className="btn btn-prim w-auto m-12"
                onClick={() => {
                  HandleLockerBack();
                }}
              >
                Back
              </button>
            </div>
          </div>
        )}
        {customerStep && (
          <div className="row text-center justify-content-center  mx-auto">
            <div className="col-lg-7  col-md-7 col-sm-7 mx-auto">
              <div className="form-box card-box">
                <form onSubmit={formSubmit}>
                  <h4 className="fw-bold fs-5">ENTER CUSTOMER DETAIL</h4>
                  <div className="row mt-5">
                    <div className="mb-3">
                      <div className="inpt-wrap">
                        <input
                          type="text"
                          className="form-control"
                          id="customerName"
                          placeholder="Customer Name"
                          name="customer_name"
                          value={customerName}
                          onChange={(e) => setCustomerName(e.target.value)}
                          onFocus={() => setActiveInput("name")}
                          required
                          autoComplete="name"
                          autoFocus
                        />
                      </div>
                    </div>
                    <div className="">
                      <div className="inpt-wrap">
                        <input
                          ref={inputRef}
                          type="email"
                          className="form-control"
                          id="sitec"
                          placeholder="Customer Email Address"
                          name="customer_email"
                          value={input}
                          onChange={(e) => setInput(e.target.value)}
                          onFocus={() => setActiveInput("email")}
                          required
                          autoComplete="email"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 text-end">
                    <button
                      type="button"
                      className="btn btn-prim w-auto m-2"
                      disabled={isFormSubmit}
                      onClick={() => {
                        HandleCustomerBck();
                      }}
                    >
                      Back
                    </button>
                    <button
                      type="submit"
                      className="btn btn-prim w-auto "
                      disabled={isFormSubmit}
                    >
                      {isFormSubmit ? "Processing..." : "Continue"}
                    </button>
                    {/* <button
                      type="button"
                      className="btn btn-prim w-auto m-2"
                      disabled={isFormSubmit}
                      onClick={() => {
                        enableKey();
                      }}
                    >
                      {enableKeyboard ? 'Disable Keyboard' : 'Enable Keyboard'}
                    </button> */}
                  </div>
                </form>
                {/* {enableKeyboard && ( */}
                <div className="keyboard">
                  {keyLayout.map((row, rowIndex) => (
                    <div key={rowIndex} className="keyboard-row">
                      {row.map((key, index) => (
                        <button
                          key={index}
                          onClick={() => handleKeyPress(key)}
                          className={`key ${
                            [
                              "Shift",
                              "Caps",
                              "Backspace",
                              "Enter",
                              "Space",
                            ].includes(key)
                              ? "special"
                              : ""
                          }`}
                        >
                          {key}
                        </button>
                      ))}
                    </div>
                  ))}
                </div>
                {/* )} */}
              </div>
            </div>
          </div>
        )}
        {successMessage && (
          <div className="row text-center justify-content-center  mx-auto">
            <div className="col-lg-7  col-md-7 col-sm-7 mx-auto">
              <div className="form-box card-box">
                <h4 className="fw-bold fs-5">
                  ORDER {pickupData?.order_number} HAS SUCCESSFULLY BEEN PLACED
                  FOR PICK UP CODE {pickupData?.pickup_code}
                </h4>
                {/* <form onSubmit={formSubmit}>
                  <div className="row mt-5">
                    <div className="">
                      <div className="inpt-wrap">
                        <input
                          type="email"
                          className="form-control"
                          id="sitec"
                          placeholder="Cutomer Email Address"
                          name="customer_email"
                          value={credentials.customer_email}
                          onChange={handleInput}
                          required
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 text-end">
                    <button
                      type="button"
                      className="btn btn-prim w-auto m-2"
                      disabled={isFormSubmit}
                      onClick={() => {
                        HandleCustomerBck();
                      }}
                    >
                      Back
                    </button>
                    <button
                      type="submit"
                      className="btn btn-prim w-auto "
                      disabled={isFormSubmit}
                    >
                      {isFormSubmit ? "Processing..." : "Continue"}
                    </button>
                  </div>
                </form> */}
              </div>
            </div>
          </div>
        )}
      </div>
      {usesLockerImage && (
        <Modal
          open={invidLockerModalOpen}
          onCancel={handleInvidActionModalClose}
          footer={null}
          centered
          width={320}
          closable
          maskClosable
          className={invidLockerStyles.invidLockerModal}
          title={
            selectedInvidLocker
              ? `Locker ${selectedInvidLocker.number}`
              : "Locker"
          }
        >
          <div className={invidLockerStyles.invidModalBody}>
            <p className={invidLockerStyles.invidModalHint}>
              Open the locker or confirm to enter customer details.
            </p>
            <div className={invidLockerStyles.invidModalActions}>
              <button
                type="button"
                className={`btn btn-prim btn-transparent ${invidLockerStyles.invidModalActionBtn}`}
                onClick={handleInvidActionModalClose}
              >
                Close
              </button>
              <button
                type="button"
                className={`btn btn-prim ${invidLockerStyles.invidModalActionBtn}`}
                disabled={!selectedLocker || loader}
                onClick={() => HandleOpenLocker(selectedLocker)}
              >
                {loader
                  ? "Opening.."
                  : showConfirm
                  ? "Re-open Locker"
                  : "Open Locker"}
              </button>
              <button
                type="button"
                className={`btn btn-prim ${invidLockerStyles.invidModalActionBtn}`}
                disabled={!selectedLocker}
                onClick={() => HandleConfirm(selectedLocker)}
                style={{
                  backgroundColor: showConfirm ? "#0d7a4f" : "#012269",
                  borderColor: showConfirm ? "#0d7a4f" : "#012269",
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};
export default PickupBook;
